<template>
  <div :style="{ margin: '2rem' }">
    <DialogLoading
      :message="loadingMessage"
      :active="loading"
    />
    <ConfirmationModal
      :active="confirmModal"
      :handleConfirm="handleAcceptConfirmModal"
      :handleCancel="handleCancelConfirmModal"
      title="Confirmar Ação"
      message="Você tem certeza que deseja marcar o cliente como devolvido/abatido?"
    />
    <v-card>
      <v-data-table
        :headers="headers"
        :items="requests"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        :disable-sort="true"
        :loading="loading"
        loading-text="Carregando... Por favor, aguarde"
        no-data-text="Nenhuma devolução pendente"
        hide-default-footer
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title class="title-bold">Devoluções e Abatimentos</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-dialog v-model="dialog" max-width="800px">
              <template v-slot:activator="{ on, attrs }">

                <v-btn color="green" dark class="mb-2 mr-2" v-on:click="exportExcel">
                  Exportar
                </v-btn>

              </template>
            </v-dialog>
          </v-toolbar>
          <v-container>
            <v-row>
              <v-col cols="12" sm="4" md="2">
                <v-select
                  :items="[{ id: 3, name: 'Devolução Solicitada'}, { id: 4, name: 'Abatimento Solicitada'}]"
                  item-text="name"
                  item-value="id"
                  no-data-text="Sem dados"
                  label="Tipo de Ação"
                  v-model="filters.act"
                />
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-select
                  :items="realStateItems"
                  item-text="name"
                  item-value="id"
                  no-data-text="Sem dados"
                  label="Imobiliária"
                  v-model="filters.realState"
                />
              </v-col>
              <v-col cols="12" sm="4" md="2">
                <v-text-field
                  label="Corretor"
                  v-model="filters.broker"
                />
              </v-col>
              <v-col cols="12" sm="4" md="2">
                <v-text-field
                  label="Data de solicitação (yyyy-mm-dd)"
                  v-model="filters.date"
                />
              </v-col>
              <v-col cols="12" sm="4" md="1">
                <v-btn color="green" class="btn-filter" text @click="getRequests">Buscar</v-btn>
              </v-col>
              <v-col cols="12" sm="4" md="1">
                <v-btn color="red" class="btn-filter" text @click="clearFilters">Limpar Filtros</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template v-slot:[`item.typeAccount`]="{ item }">
         {{  item.devolution ? item.devolution.type_account === 'C' ? 'Corrente' : 'Poupança' : '' }}
        </template>
        <template v-slot:[`item.bank`]="{ item }">
         {{ item.devolution ? item.devolution.code_bank : '' }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            @click="finished(item)"
          >
            mdi-chevron-down-circle-outline
          </v-icon>
        </template>
        <template v-slot:no-data>
          Sem dados
        </template>
      </v-data-table>
      <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
    </v-card>
  </div>
</template>

<script>
import DialogLoading from '@/components/loading/DialogLoading'
import ConfirmationModal from '@/components/modals/ConfirmationModal'
import message from '@/utils/message'
import api from '@/services/api'
import jsonxlsx from 'json-as-xlsx'

export default {
  components: {
    DialogLoading,
    ConfirmationModal
  },

  data: () => ({
    itemToFinish: null,
    confirmModal: false,
    dialog: false,
    loading: false,
    loadingMessage: 'Carregando',
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    realStateItems: [],
    headers: [
      { text: 'Cliente', align: 'start', value: 'client.name' },
      { text: 'Solicitação', value: 'paymentStatus.name' },
      { text: 'Tipo de conta', value: 'typeAccount' },
      { text: 'Cód. Banco', value: 'bank' },
      { text: 'Agência', value: 'devolution.ag' },
      { text: 'Conta', value: 'devolution.account' },
      { text: 'Titular', value: 'devolution.name' },
      { text: 'Tipo Chave Pix', value: 'devolution.pixKey.name' },
      { text: 'Chave Pix', value: 'devolution.pix_value' },
      { text: 'Solicitação realizada?', value: 'actions', sortable: false }
    ],
    requests: [],
    editedIndex: -1,
    filters: {
      act: null,
      broker: null,
      realState: null,
      date: null
    }
  }),

  created () {
    this.getRealEstates()
  },

  methods: {
    async getRequests () {
      try {
        this.loading = true
        const { data } = await api.get(`/requests?act=${this.filters.act}&broker=${this.filters.broker}&realState=${this.filters.realState}&date=${this.filters.date}`)
        this.requests = data
      } catch (error) {
        message.error(error.message)
      } finally {
        this.loading = false
      }
    },

    exportExcel () {
      try {
        const dataExcel = [{
          sheet: 'Lista',
          columns: [
            { label: 'Nome', value: row => row.client.name },
            { label: 'Solicitação', value: row => row.paymentStatus.name },
            { label: 'Tipo de conta', value: row => row.devolution ? row.devolution.type_account === 'C' ? 'Corrente' : 'Poupança' : '' },
            { label: 'Cód. Banco', value: row => row.devolution ? row.devolution.code_bank : '' },
            { label: 'Agência', value: row => row.devolution ? row.devolution.ag : '' },
            { label: 'Conta', value: row => row.devolution ? row.devolution.account : '' },
            { label: 'Titular', value: row => row.devolution ? row.devolution.name : '' },
            { label: 'Tipo Chave Pix', value: row => row.devolution ? row.devolution.pixKey.name : '' },
            { label: 'Chave Pix', value: row => row.devolution ? row.devolution.pix_value : '' }
          ],
          content: this.requests
        }]

        const settings = {
          fileName: 'Solicitações',
          extraLength: 3,
          writeOptions: {}
        }

        jsonxlsx(dataExcel, settings)
      } catch (error) {
        message.error(error.message)
      }
    },

    async finished (item) {
      try {
        this.loading = true
        const status = item.payment_status_id === 3 ? 6 : 5
        await api.put(`reserves/${item.id}/payment-status`, { payment_status_id: status })
        const index = this.requests.indexOf(item)
        this.requests.splice(index, 1)
        message.success('Devolução realizada')
      } catch (error) {
        message.error(error.message)
      } finally {
        this.loading = false
      }
    },

    async getRealEstates () {
      try {
        const { data } = await api.get('/real-states?page=-1&itemsPerPage=-1')
        this.realStateItems = data.data
      } catch (error) {
        message.error(error.message)
      }
    },

    clearFilters () {
      this.filters.act = null
      this.filters.realState = null
      this.filters.broker = null
      this.filters.date = null
    },

    handleCancelConfirmModal () {
      this.confirmModal = false
    },

    handleAcceptConfirmModal () {
      this.confirmModal = false
      this.finished()
    },

    openConfirmModal (item) {
      this.itemToFinish = item
      this.confirmModal = true
    }
  }
}
</script>

<style scoped>
  .btn-filter {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/requests/Requests.vue